import axios from 'axios'
import store from '~/store'
import router from '~/router'
import i18n from './vue-i18n'
import Vue from 'vue'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

axios.interceptors.request.use(request => {
  if (store.getters.authToken) {
    request.headers.common['Authorization'] = `Bearer ${store.getters.authToken}`
  }
  return request
})

axios.interceptors.response.use(
  response => response,
  error => {
    const { status } = error.response

    //   if (status >= 500) {
    //     if (error.response.data.errors) {
    //       store.dispatch('responseMessage', {
    //         type: 'red',
    //         text: error.response.data.errors.message
    //       })
    //     } else {
    //       store.dispatch('responseMessage', {
    //         type: 'red',
    //         text: error.response.data.message
    //       })
    //     }
    //   }

    if ((status === 401 || status === 403) && store.getters.authCheck) {
      store.dispatch('responseMessage', {
        type: 'red',
        text: i18n.t('token_expired_alert_text')
      })
        .then(async () => {
          store.dispatch('logout')

          router.push({ name: 'login' })
        })
    } else if (status === 401) {
      store.dispatch('responseMessage', {
        type: 'red',
        text: error.response.data.errors.message
      })
    } else if (status === 422) {
      store.dispatch('responseMessage', {
        type: 'red',
        text: error.response.data.errors.message
      })
    }

    return Promise.reject(error)
  })

// Make axios globaly available via $http or axios

Vue.axios = axios

Object.defineProperties(Vue.prototype, {
  axios: {
    get () {
      return axios
    }
  },
  $http: {
    get () {
      return axios
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js